module.exports = __webpack_public_path__ + "static/img/broadcast.089affbc.png";